import _ from 'lodash'

import { addDaysToDate, getDateString, getPMUserNameByUserId } from "../../../utils"


const PIWiseInvoiceBookingAlertsDialog = (props) => {

    const { duplicatePIPunches, pmCompanyUsers } = props
    let {  sellerPOItemsWithVendorPaymentButGRNNotDone } = props

    sellerPOItemsWithVendorPaymentButGRNNotDone = _.sortBy(sellerPOItemsWithVendorPaymentButGRNNotDone, 'docNo')

    const sellerPOItemsWithDeliveryPending = sellerPOItemsWithVendorPaymentButGRNNotDone.filter(eachPOItem => {
        const diff = eachPOItem.modifiedDeliveryDate < new Date()
        return diff
    })

    return (
        <>
            {
                duplicatePIPunches.length > 0 &&
                <div className="mb-1 mt-1">
                    <h4 className="m-0">Duplicate PI Punches</h4>
                    <div className="custom-table-container">
                        <table className="custom-prodcut-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">Seller PI Doc No</th>
                                    <th className="">Seller PO Doc No</th>
                                    <th className="">seller PI Number</th>
                                    <th className="">seller PI Total Amount</th>
                                    <th className="">Seller PI Created Date</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                {
                                    duplicatePIPunches.map(eachDuplicatePIPunch => {
                                        return (
                                            <tr key={`sellerPIPunch-${eachDuplicatePIPunch.sellerPIPunchItemId}`}  className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                                <td className="">{eachDuplicatePIPunch.docNo}</td>
                                                <td className="">{eachDuplicatePIPunch.sellerPODocNo}</td>
                                                <td className="">{eachDuplicatePIPunch.sellerPINumber}</td>
                                                <td className="">{eachDuplicatePIPunch.sellerPITotalAmount}</td>
                                                <td className="">{getDateString(eachDuplicatePIPunch.createdAt)}</td>
                                            </tr>
                                        )
                                    })}
                            </tbody>
                        </table>
                    </div>
                </div>
            }
            {
                sellerPOItemsWithDeliveryPending.length ?
                    <div className="mb-1 mt-1">
                        <h4 className="m-0">Materials with advance vendor payment was done but delivery delayed</h4>
                        <div className="custom-table-container">
                            <table className="custom-product-table" style={{ width: "100%" }}>
                                <thead >
                                    <tr className="">
                                        <th className="">Material ID</th>
                                        <th className="">Seller PO Doc No</th>
                                        <th className="">KAM name</th>
                                        <th className="">Seller PO created date</th>
                                        <th className="">Delivery date</th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                    {
                                        sellerPOItemsWithDeliveryPending.map(eachPOItem => {
                                            const kamName = getPMUserNameByUserId(pmCompanyUsers, eachPOItem.createdBy)
                                            const deliveryDate = getDateString(addDaysToDate(eachPOItem.createdAt, parseInt(eachPOItem.leadTime)))

                                            return (
                                                <tr key={eachPOItem.sellerPOItemId} className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                                    <td className="">{eachPOItem.materialId}</td>
                                                    <td className="">{eachPOItem.docNo}</td>
                                                    <td className="">{kamName}</td>
                                                    <td className="">{getDateString(eachPOItem.createdAt)}</td>
                                                    <td className="">{deliveryDate}</td>
                                                </tr>
                                            )
                                        })}
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
            {
                sellerPOItemsWithVendorPaymentButGRNNotDone.length ?
                    <div className="mb-1 mt-1">
                        <h4 className="m-0">Materials with advance vendor payment was done but not recieved yet</h4>
                        <div className="custom-table-container">
                            <table className="custom-product-table" style={{ width: "100%" }}>
                                <thead >
                                    <tr className="">
                                        <th className="">Material ID</th>
                                        <th className="">Seller PO Doc No</th>
                                        <th className="">KAM name</th>
                                        <th className="">Seller PO created date</th>
                                        <th className="">Delivery date</th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                    {
                                        sellerPOItemsWithVendorPaymentButGRNNotDone.map(eachPOItem => {
                                            let kamName = ''
                                            if(eachPOItem.createdBy){
                                                kamName = getPMUserNameByUserId(pmCompanyUsers, eachPOItem.createdBy)
                                            }

                                            let deliveryDate = ''
                                            if(eachPOItem.createdAt){
                                                deliveryDate = getDateString(addDaysToDate(eachPOItem.createdAt, parseInt(eachPOItem.leadTime)))
                                            }

                                            let createdAtDate = ''
                                            if(eachPOItem.createdAt){
                                                createdAtDate = getDateString(eachPOItem.createdAt)
                                            }

                                            return (
                                                <tr key={`sellerPOItem-${eachPOItem.sellerPOItemId}`} className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                                    <td className="">{eachPOItem.materialId}</td>
                                                    <td className="">{eachPOItem.docNo}</td>
                                                    <td className="">{kamName}</td>
                                                    <td className="">{createdAtDate}</td>
                                                    <td className="">{deliveryDate}</td>
                                                </tr>
                                            )
                                        })}
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
        </>
    )
}

export default PIWiseInvoiceBookingAlertsDialog